import React, { useState } from "react";
import { Button, Input, Modal } from "antd";
import { toast } from "react-toastify";

import { FaQrcode } from "react-icons/fa";

import {
  generateQRCode,
  checkQRCode,
  loginQRCode,
  saveVoucher,
} from "../../api/checkmvd";
import { ParticlesComponent } from "../../components";

const Voucher50k = () => {
  const [qrCodeBase64, setQrCodeBase64] = useState("");
  const [loadingQR, setLoadingQR] = useState(false);
  const [qrData, setQrData] = useState(null);
  const [cookie, setCookie] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isManualCookieVisible, setIsManualCookieVisible] = useState(false);

  const openManualCookiePopup = () => {
    setIsManualCookieVisible(true);
  };

  const closeManualCookiePopup = () => {
    setIsManualCookieVisible(false);
  };

  const fetchQRCode = async () => {
    setLoadingQR(true);
    try {
      const qrData = await generateQRCode();
      if (qrData && qrData.qrcode_base64 && qrData.qrcode_id) {
        setQrCodeBase64(qrData.qrcode_base64);
        setQrData(qrData);
        setIsModalVisible(true);
        await pollQRCodeStatus(qrData.qrcode_id);
      }
    } catch (error) {
      toast.error("Lỗi khi tạo QR code:", error);
    }
    setLoadingQR(false);
  };

  const pollQRCodeStatus = async (qrcodeId) => {
    for (let i = 0; i < 12; i++) {
      try {
        const statusData = await checkQRCode(qrcodeId);
        if (statusData && statusData.status === "CONFIRMED") {
          const qrcodeToken = statusData.qrcode_token;
          const loginData = await loginQRCode(qrcodeToken);
          if (loginData && loginData.cookie) {
            setCookie(loginData.cookie);
            setIsModalVisible(false);
          }
          break;
        }
      } catch (error) {
        toast.error("Lỗi khi kiểm tra trạng thái QR code:", error);
      }
      await new Promise((resolve) => setTimeout(resolve, 5000));
    }
  };

  const handleSubmit = async () => {
    try {
      const response = await saveVoucher(cookie);
      if (response && response.error === 0) {
        toast.success("Lưu voucher thành công");
      } else if (response && response.error === 5) {
        toast.warning("Bạn đã lưu voucher này trước đó");
      } else {
        toast.error("Đã xảy ra lỗi khi lưu voucher");
      }
    } catch (error) {
      console.error("Error saving voucher:", error);
      toast.error("Đã xảy ra lỗi khi lưu voucher");
    }
  };

  return (
    <div>
      <ParticlesComponent id="particles-js" />
      <div className=" py-8 flex items-center justify-center">
        <div className="max-w-[800px] space-y-8 ">
          {/* <Button type="primary" onClick={fetchQRCode} loading={loadingQR}>
            <div className="flex items-center justify-between space-x-2">
              <FaQrcode /> <div>Tạo QR Code</div>
            </div>
          </Button> */}
          <Input.TextArea
            value={cookie}
            onChange={(e) => setCookie(e.target.value)}
            placeholder="Nhập cookie vào đây"
            autoSize={{ minRows: 3, maxRows: 5 }}
          />
          <Button type="primary" onClick={handleSubmit}>
            Submit
          </Button>
          {/* Hiển thị QR code */}
          <Modal
            title="QR Code"
            open={isModalVisible}
            onCancel={() => setIsModalVisible(false)}
            footer={null}
          >
            <img src={`data:image/png;base64,${qrCodeBase64}`} alt="QR Code" />
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default Voucher50k;
